// extracted by mini-css-extract-plugin
export default {"animated_image":"product8p_animated_image__Etj1o","rotateAndShrink":"product8p_rotateAndShrink__Xvc3e","container":"product8p_container__bDflF"};